export default {"src":"/_next/static/media/footer-bg.35ad8a9e.svg","height":414,"width":1920,"blurWidth":0,"blurHeight":0};